import type { QueryResult } from '@apollo/client';
import { gql, useQuery } from '@apollo/client';

import type {
  CountryQuery,
  CountryQuery_magento2,
  CountryQueryVariables,
} from './__generated__/CountryQuery';

type Result = QueryResult<CountryQuery>;

type UseCountryDataHookResult = Omit<Result, 'data'> & {
  data: CountryQuery_magento2['country'];
};

const useCountryData = (id?: string | null): UseCountryDataHookResult => {
  const { data, ...queryState } = useQuery<CountryQuery, CountryQueryVariables>(
    countryQuery,
    {
      variables: { id },
      skip: !id,
      fetchPolicy: 'cache-first',
      ssr: false,
    },
  );

  return { data: data?.magento2?.country ?? null, ...queryState };
};

export default useCountryData;

export const countryQuery = gql`
  query CountryQuery($id: String) {
    magento2 {
      country(id: $id) {
        id
        fullNameLocale
      }
    }
  }
`;
